import React, { memo, useCallback, useState } from 'react';
import { Form } from 'react-bootstrap';

import Alert from 'src/components/common/modal/alert/alert';
import { SearchResult } from 'src/components/main/quiz/hometown-step/components/search-results';
import { useDebounce } from 'src/utils/hooks/use-debounce';

import styles from './search-modal.module.scss';

export const SearchModal = memo(
  ({
    show,
    handleSelect,
  }: {
    show: boolean;
    handleSelect: (value: string, latitude: number, longitude: number) => void;
  }) => {
    const [hometownValue, setHometownValue] = useState('');
    const debouncedValue = useDebounce(hometownValue);

    const handleChange = useCallback(
      (event: React.ChangeEvent<HTMLInputElement>) => {
        setHometownValue(event.target.value);
      },
      [],
    );

    return (
      <Alert canClose={false} show={show} className={styles.container}>
        <Form.Control
          value={hometownValue}
          placeholder="Enter your city"
          onChange={handleChange}
        />

        <SearchResult
          handleSelect={handleSelect}
          debouncedValue={debouncedValue}
        />
      </Alert>
    );
  },
);
SearchModal.displayName = 'SearchModal';
